import classes from "../../styles/components/statusButtons.module.scss";

function StatusWorkButton() {
    return(
        <button className={`${classes.workProject} ${classes.button}`}>● work project</button>
    );
}

export default StatusWorkButton;